
export const SocialButton = (props: any) => {
  return (
    <a className="social-button" href={props.to} target="_blank">
      <img src={props.image} />
    </a>
  );
};